import React from "react";

export default function MySQL_LCASE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_LCASE</h1>
      <p>This is the MySQL_LCASE component generated from the SQL JSON.</p>
    </div>
  );
}
